export default "__VITE_ASSET__DvPhQY1d__"